import React from "react";
import serviceImage1 from "../../../Assets/Home/Service/service1.png";
import serviceImage2 from "../../../Assets/Home/Service/service2.png";
import serviceImage3 from "../../../Assets/Home/Service/service3.png";
import { FaFlask, FaMicroscope, FaVial, FaCapsules, FaCalendarAlt } from "react-icons/fa";
import { FaArrowRightLong } from "react-icons/fa6";
import HeadingTexts from "../../common/HeadingTexts";

const Stories = () => {
  const services = [
    {
      image: serviceImage1,
      date: "April 16, 2025",
      category: "Biochemistry",
      title: "The Role of Medical Laboratories In Infectious Diseases",
    },
    {
      image: serviceImage2,
      date: "May 10, 2025",
      category: "Microbiology",
      title: "Advances in Vaccine Development and Testing",
    },
    {
      image: serviceImage3,
      date: "June 5, 2025",
      category: "Pathology",
      title: "Diagnostic Innovations for Early Detection",
    },
    {
      image: serviceImage1,
      date: "July 20, 2025",
      category: "Genetics",
      title: "The Impact of Genomics on Personalized Medicine",
    },
  ];

  return (
    <div className="pb-16 md:px-10 px-6 bg-[#fafafa]">
      <HeadingTexts label='Recent Articles' text='Innovation in Focus Stories' bluetext='Updated From Lab' position='center' />
      <div className="grid xl:grid-cols-4 mt-10 md:grid-cols-2 grid-cols-1 gap-10">
        {services.map((service, index) => (
          <div data-aos="zoom-in-up"
            key={index}
            className="bg-white rounded-2xl overflow-hidden shadow-md transition-all duration-300 hover:shadow-lg"
          >
            {/* Top Image */}
            <div className="h-64 w-full overflow-hidden">
              <img
                src={service.image}
                alt={service.title}
                className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
              />
            </div>
            {/* Card Content */}
            <div className="p-4 rounded-t-2xl">
              <div data-aos="zoom-in-up" className="flex items-center gap-2 mb-3">
                <span className="bg-blue-100 text-primaryColor px-3 py-1 rounded-full text-sm font-medium flex items-center gap-1">
                  <FaCalendarAlt className="text-xs" />
                  {service.date}
                </span>
                <span className="bg-blue-100 text-primaryColor px-3 py-1 rounded-full text-sm font-medium flex items-center gap-1">
                  <FaFlask className="text-xs" />
                  {service.category}
                </span>
              </div>
              <div className="h-0.5 bg-gray-200 my-4"></div>
              <h3 data-aos="zoom-in-up" className="text-lg font-semibold familjen-font text-gray-800 mb-3 line-clamp-2 text-center  ">
                {service.title}
              </h3>
              {/* <button className="text-primaryColor mx-auto font-medium flex items-center gap-1 ">
                Read More
                <FaArrowRightLong />
              </button> */}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Stories;